export default __webpack_public_path__ + "static/landscapes-fifth-fd4ccd19aecb00ea1385dbc97aee9cba.webp";